import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_dislike",
  "use": "svg_dislike-usage",
  "viewBox": "0 0 31 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31 28\" id=\"svg_dislike\"><path d=\"M25 0h6v17h-6V0ZM0 15.243l.014-.111L0 12.472c0-.36.071-.693.2-1.012l4.314-9.77C4.943.694 5.957 0 7.143 0H20c1.571 0 2.857 1.247 2.857 2.771V16.63a2.67 2.67 0 0 1-.843 1.953l-9.4 9.132L11.1 26.26a2.055 2.055 0 0 1-.629-1.469l.043-.443 1.357-6.333H2.857C1.286 18.014 0 16.767 0 15.243Z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol